"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadFile = loadFile;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _zipObject = _interopRequireDefault(require("lodash/zipObject"));

var errorUtils = _interopRequireWildcard(require("./errorUtils"));

var fileUtils = _interopRequireWildcard(require("./fileUtils"));

var allowAdditionalColumns = 'allow';
var disallowAdditionalColumns = 'disallow';
var ignoreAdditionalColumns = 'ignore';
var defaultMaxFileSizeMb = 15;
var defaultMaxFileSize = 1024 * 1024 * defaultMaxFileSizeMb;

function getFullOptions(options) {
  var _options$additionalCo = options.additionalColumns,
      additionalColumns = _options$additionalCo === void 0 ? allowAdditionalColumns : _options$additionalCo,
      _options$maxFileSize = options.maxFileSize,
      maxFileSize = _options$maxFileSize === void 0 ? defaultMaxFileSize : _options$maxFileSize,
      _options$optionalColu = options.optionalColumns,
      optionalColumns = _options$optionalColu === void 0 ? [] : _options$optionalColu,
      _options$requiredColu = options.requiredColumns,
      requiredColumns = _options$requiredColu === void 0 ? [] : _options$requiredColu;
  var fixedOptionalColumns = (0, _isFunction.default)(optionalColumns) ? optionalColumns() : optionalColumns;
  var fixedRequiredColumns = (0, _isFunction.default)(requiredColumns) ? requiredColumns() : requiredColumns;
  var allColumns = [].concat((0, _toConsumableArray2.default)(fixedOptionalColumns || []), (0, _toConsumableArray2.default)(fixedRequiredColumns || []));
  return {
    additionalColumns: additionalColumns,
    allColumns: allColumns,
    maxFileSize: maxFileSize,
    optionalColumns: fixedOptionalColumns,
    requiredColumns: fixedRequiredColumns
  };
}

function filterColumns(columns, rows, options) {
  var additionalColumns = options.additionalColumns,
      allColumns = options.allColumns,
      requiredColumns = options.requiredColumns; // Format all of the rows to be objects.

  var formattedRows = rows.map(function (row) {
    return (0, _zipObject.default)(columns, row);
  }); // Build sets of columns for quicker indexing.

  var allColumnsSet = new Set(allColumns);
  var columnsSet = new Set(columns); // Determine all duplicate columns.

  var duplicateColumns = columns.filter(function (column, idx) {
    return (0, _includes.default)(columns, column, idx + 1);
  });
  var uniqueDuplicates = (0, _uniq.default)(duplicateColumns);

  if (uniqueDuplicates.length) {
    return errorUtils.buildError(errorUtils.duplicateColumnNames(uniqueDuplicates));
  } // Determine all columns that are missing.


  var missingColumns = requiredColumns.filter(function (column) {
    return !columnsSet.has(column);
  });

  if (missingColumns.length) {
    return errorUtils.buildError(errorUtils.missingColumns(missingColumns));
  } // Dtermine all columns that are present when they should not be.


  var extraColumns = columns.filter(function (column) {
    return !allColumnsSet.has(column);
  });

  if (extraColumns.length && additionalColumns === disallowAdditionalColumns) {
    return errorUtils.buildError(errorUtils.tooManyColumns(extraColumns));
  }

  var filteredColumns = additionalColumns === ignoreAdditionalColumns ? columns.filter(function (column) {
    return allColumnsSet.has(column);
  }) : columns;

  if (filteredColumns.length === 0) {
    return errorUtils.buildError(errorUtils.noColumns());
  }

  var filteredRows = additionalColumns === ignoreAdditionalColumns ? formattedRows.map(function (row) {
    return (0, _pick.default)(row, filteredColumns);
  }) : formattedRows;
  return {
    columns: filteredColumns,
    rows: filteredRows,
    error: null
  };
}

function loadFile(_x, _x2) {
  return _loadFile.apply(this, arguments);
}

function _loadFile() {
  _loadFile = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(file, options) {
    var fullOptions, fileExtension, fileContents, _fileContents, columns, rows, error;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fullOptions = getFullOptions(options);

            if (file) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", errorUtils.buildError(errorUtils.failedToReadFile(file)));

          case 3:
            if (!(file.size > fullOptions.maxFileSize)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", errorUtils.buildError(errorUtils.fileTooLarge(file.size, fullOptions.maxFileSize)));

          case 5:
            fileExtension = fileUtils.getFileExtension(file);
            fileContents = null;
            _context.t0 = fileExtension;
            _context.next = _context.t0 === 'xls' ? 10 : _context.t0 === 'xlsx' ? 10 : _context.t0 === 'xlsb' ? 10 : _context.t0 === 'csv' ? 14 : 18;
            break;

          case 10:
            _context.next = 12;
            return fileUtils.readXlsFile(file);

          case 12:
            fileContents = _context.sent;
            return _context.abrupt("break", 19);

          case 14:
            _context.next = 16;
            return fileUtils.readCsvFile(file);

          case 16:
            fileContents = _context.sent;
            return _context.abrupt("break", 19);

          case 18:
            return _context.abrupt("return", errorUtils.buildError(errorUtils.unsupportedFileType()));

          case 19:
            if (fileContents) {
              _context.next = 21;
              break;
            }

            return _context.abrupt("return", errorUtils.buildError(errorUtils.failedToReadFile(file)));

          case 21:
            _fileContents = fileContents, columns = _fileContents.columns, rows = _fileContents.rows, error = _fileContents.error;

            if (!error) {
              _context.next = 24;
              break;
            }

            return _context.abrupt("return", errorUtils.buildError(error));

          case 24:
            return _context.abrupt("return", filterColumns(columns, rows, fullOptions));

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadFile.apply(this, arguments);
}